import domReady from '../utils/domReady';

const articleAside = () => {
  domReady(() => {
    const headerEl = document.querySelector('.c-header');
    const asideElNodelist = document.querySelectorAll('.c-article__aside');
    const asideElArr = Array.from(asideElNodelist);
    const asideElWithButtons = asideElArr.find((el) => el.classList.contains('c-article__aside--buttons'))
    const [ lastAsideEl ] = asideElArr.slice(-1)

    if (asideElWithButtons) {
      let options = {
        rootMargin: `${headerEl.getBoundingClientRect().height}px 0px 0px  0px`,
        threshold: 1.0,
      }

      let callback = (entries, observer) => {
        let previousY = 0
        let previousRatio = 0

        entries.forEach(entry => {
          const currentY = entry.boundingClientRect.y
          const currentRatio = entry.intersectionRatio
          const isIntersecting = entry.isIntersecting

          if (currentY < previousY) {
            if (currentRatio > previousRatio && isIntersecting) {
              asideElWithButtons.classList.remove('is-fixed')
            } else {
              asideElWithButtons.classList.add('is-fixed')
            }
          }

          previousY = currentY
          previousRatio = currentRatio
        });
      };

      let observer = new IntersectionObserver(callback, options)

      if (lastAsideEl) observer.observe(lastAsideEl)
    }
  })
}

articleAside()
